<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2z"><a id="page_vi"></a><a id="page_vii"></a>CONTENTS</h2>
<p class="toca"><a href="#/xhtml/acknowledgments#ack">ACKNOWLEDGMENTS</a></p>
<p class="toct"><a href="#/xhtml/ch01#ch1">1 An Invitation to Israel Literacy</a> <em>/ S. Ilan Troen, and Rachel Fish</em></p>
<p class="toc"><a href="#/xhtml/ch02#ch2">2 Israel: Geography, Demography, and Economy</a> <em>/ S. Ilan Troen, Maoz Azaryahu, and Arnon Golan</em></p>
<p class="toc"><a href="#/xhtml/ch03#ch3">3 From Zionism to Zion</a> <em>/ Michael Brenner</em></p>
<p class="toc"><span href="#/xhtml/ch04#ch4" title="Link target outside of Sample">4 Zionist Settlement in the Land of Israel/Palestine</span> <em>/ S. Ilan Troen</em></p>
<p class="toc"><span href="#/xhtml/ch05#ch5" title="Link target outside of Sample">5 The Arab-Israeli Conflict</span> <em>/ Alan Dowty</em></p>
<p class="toc"><span href="#/xhtml/ch06#ch6" title="Link target outside of Sample">6 History of the Peace Process</span> <em>/ David Makovsky</em></p>
<p class="toc"><span href="#/xhtml/ch07#ch7" title="Link target outside of Sample">7 Israel in World Opinion</span> <em>/ Gil Troy</em></p>
<p class="toc"><span href="#/xhtml/ch08#ch8" title="Link target outside of Sample">8 Israel: A Jewish Democracy</span> <em>/ Yedidia Stern</em></p>
<p class="toc"><span href="#/xhtml/ch09#ch9" title="Link target outside of Sample">9 Citizenship and Democracy in Israel</span> <em>/ Donna Robinson Divine</em></p>
<p class="toc1"><span href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 Israel, American Jews, and Jewish Peoplehood</span> <em>/ Steven Bayme</em></p>
<p class="toc1"><span href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 “Jewishness” in Israel: Israel as a Jewish State</span> <em>/ David Ellenson</em></p>
<p class="toc1"><span href="#/xhtml/ch12#ch12" title="Link target outside of Sample">12 Contemporary Christianity and Israel</span> <em>/ Yaakov Ariel</em></p>
<p class="toc1"><span href="#/xhtml/ch13#ch13" title="Link target outside of Sample">13 Perceptions and Understandings of Israel within Islam</span> <em>/ Norman Stillman</em></p>
<p class="toc1"><span href="#/xhtml/ch14#ch14" title="Link target outside of Sample">14 “Hebrewism” and Israeli Culture</span> <em>/ Rachel S. Harris</em></p>
<p class="toc1"><span href="#/xhtml/ch15#ch15" title="Link target outside of Sample">15 Israeli and Hebrew Literature: from the Yishuv to the 21st Century</span> <em>/ Ranen Omer-Sherman</em></p>
<p class="tocat"><span href="#/xhtml/glossary#glo" title="Link target outside of Sample"><span class="small">GLOSSARY</span></span> <em>/ Carol Troen</em></p>
<p class="toca"><span href="#/xhtml/timeline#tim" title="Link target outside of Sample"><span class="small">TIMELINE:</span> <em>A Century of Wars and Conflict and Peace Negotiations and Agreements 1917-2016</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e47aade6